import { render, staticRenderFns } from "./ComplaintEmisorDownloadAttachment.vue?vue&type=template&id=ceef0742"
import script from "./ComplaintEmisorDownloadAttachment.vue?vue&type=script&lang=js"
export * from "./ComplaintEmisorDownloadAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports